export default __webpack_public_path__ + "static/media/640_store04-es-web.354ae232.png";